import React from 'react';
import PropTypes from 'prop-types';


const _24_05_2025 = () => (
 
   
    <div>
       _24_05_2025 Component
      <h1>
         my todos.
         <ol> todo 1</ol>
         <ol> todo 2</ol>
      </h1>
    </div>
 

);

_24_05_2025.propTypes = {};

_24_05_2025.defaultProps = {};

export default _24_05_2025;
